// STRUCT CODE 5軸の正式定義 (2026-05-18 ユーザー確定)
//
// 表示は「両極スライダー」: 左極 ↔ 右極、ノブで右極寄りの度合いを示す
// スコア × 100 = 右極の % として表示
//
// 内部キー (activation / judgment / choice / resonance / awareness) は不変。
// バックエンドの計算とデータ互換性を保つため、key は絶対に変えない。

const AXIS_DEFS = [
  {
    key: 'activation',
    beKey: '起動軸',         // バックエンド axes object のキー (不変)
    label_ja: '行動特性',
    label_en: 'Behavioral',
    pole_left_ja:  '応答',
    pole_left_en:  'Reactive',
    pole_right_ja: '自発',
    pole_right_en: 'Proactive',
    color: '#F4B860',       // 太陽琥珀
    colorKey: 'starAmber',
  },
  {
    key: 'judgment',
    beKey: '判断軸',
    label_ja: '判断基準',
    label_en: 'Judgment',
    pole_left_ja:  '直感',
    pole_left_en:  'Intuition',
    pole_right_ja: '論理',
    pole_right_en: 'Logic',
    color: '#6B8CCB',       // 水星青
    colorKey: 'starBlue',
  },
  {
    key: 'choice',
    beKey: '選択軸',
    label_ja: '価値観',
    label_en: 'Values',
    pole_left_ja:  '実利',
    pole_left_en:  'Pragmatic',
    pole_right_ja: '理想',
    pole_right_en: 'Idealistic',
    color: '#9C7BC9',       // 木星紫
    colorKey: 'starViolet',
  },
  {
    key: 'resonance',
    beKey: '共鳴軸',
    label_ja: '共感性',
    label_en: 'Empathy',
    pole_left_ja:  '自律',
    pole_left_en:  'Independent',
    pole_right_ja: '共感',
    pole_right_en: 'Empathetic',
    color: '#D08A8A',       // 金星薔薇
    colorKey: 'starRose',
  },
  {
    key: 'awareness',
    beKey: '自覚軸',
    label_ja: '自己認識',
    label_en: 'Self-Awareness',
    pole_left_ja:  '実践',
    pole_left_en:  'Action',
    pole_right_ja: '内省',
    pole_right_en: 'Reflection',
    color: '#7FB89A',       // 月白
    colorKey: 'starMint',
  },
];

// バックエンド axes object から該当軸のスコアを取得 (be キー優先、 fallback で英 key)
export const getAxisScore = (axes, axisDef) => {
  if (!axes) return null;
  if (axisDef.beKey && axes[axisDef.beKey] !== undefined) return axes[axisDef.beKey];
  if (axes[axisDef.key] !== undefined) return axes[axisDef.key];
  return null;
};

export const getAxisDef = (key) => AXIS_DEFS.find(a => a.key === key);

export const getAxisLabel = (key, lang = 'ja') => {
  const a = getAxisDef(key);
  if (!a) return key;
  return lang === 'en' ? a.label_en : a.label_ja;
};

// スコアからの右極 % (0-100、整数四捨五入)
export const scoreToPercent = (score) => {
  if (typeof score !== 'number' || isNaN(score)) return null;
  const v = Math.max(0, Math.min(1, score));
  return Math.round(v * 100);
};

export default AXIS_DEFS;
